export default __webpack_public_path__ + "static/media/11.b848a855.png";